<template>
	    
  <div id="app">

		<transition :name="transitionName">
			<div>
      <keep-alive>
        <router-view :key="key" class="child-view" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view :key="key" class="child-view" v-if="!$route.meta.keepAlive"></router-view>
		</div>
    </transition>
    <van-popup class="w-70" v-model="siteShutdown" :close-on-click-overlay="false"><van-empty image="error" description="网站关闭" /></van-popup>
    <van-popup v-model="showTip" class="share-tip"><img class="fr" :src="getImgBase+'share.png'"></van-popup>
  </div>
</template>
 
<script>
import qs from 'qs'
export default {
  name: 'App',
  data () {
    return {
      appInit:localStorage.appInit?JSON.parse(localStorage.appInit):{},
      transitionName: 'slide-left',
      getImgBase:this.$getImgBase(),
      noticePop:false,
      noticeInfo:{},
      siteShutdown:false,
      showTip:false
    }
  },
  watch: {
    $route(to, from) {
        this.appInitLoad()
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    }
  },
  computed: {
      key() {
		  // if (this.$route.name == 'store-detail') {
			 //  return this.$route.path + Math.random();
		  // }
       // return this.$route.name !== undefined
        //  ? this.$route.name + +this.$route.params
         // : this.$route + +new Date();
      }
    },
  mounted: function() {

    this.checkLocalStorageEnabled();
  },
  methods: {
    checkLocalStorageEnabled() {
      if (!this.Util.isLocalStorage()) {
        this.$toast.error('Your device does not support localStorage and cannot be used!');
        this.$router.replace({name: 'home'});
      }
    },
    appInitLoad(){
      if(!localStorage.appInit){
			  this.$setHeader()
        this.$http.get('init',{}).then((response) => {
          const _json = response.data
          if(_json.code==200){
            this.appInit = _json.data
            this.$setItem('appInit',JSON.stringify(this.appInit))

            if(this.appInit.site_open!=1){ //站点关闭
              this.siteShutdown=true
              return
            }

            if(this.appInit.start_open==1){ //站点公告
              this.$dialog.alert({
                title: this.appInit.start_title,
                message: this.appInit.start_desc,
                messageAlign:'left'
              }).then(() => {
                sessionStorage.play = 1
              });
            }
          }else{
			  	this.$toastText("errot11")
            this.$dataError(_json)
          }
        }).catch((error) => {
			console.log("app",error)
			this.$toastText("app")
          this.$toastText()
        });
      }
      if(localStorage.token&&!localStorage.userInfo){
        this.$reloadUserInfo()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue